module.exports = __webpack_public_path__ + "img/ma.4fbefb29.svg";